"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
/**
 * Directive to display custom icons from generated icon font.
 *
 * Example usage:
 * @usage
 * ```html
 * <custom-icon set="mySet" name="myIcon"></custom-icon>
 * ```
 *
 * @author Gerrit Erpenstein
 */
var CustomIcon = (function () {
    function CustomIcon(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
         * Icon name
         */
        this.iconName = '';
        /**
         * Icon set name
         */
        this.iconSet = '';
    }
    /**
     * Called on input parameter value changes.
     */
    CustomIcon.prototype.ngOnChanges = function (changes) {
        this._update();
    };
    /**
     * Update and set element's css class value.
     * @private
     */
    CustomIcon.prototype._update = function () {
        // remove old css class value
        if (this._class)
            this._renderer.setElementClass(this._elementRef.nativeElement, this._class, false);
        if (!this.iconName || !this.iconSet) {
            // invalid input parameters
            this._class = undefined;
            return;
        }
        // new css class value
        this._class = this.iconSet + '-' + this.iconName;
        this._renderer.setElementClass(this._elementRef.nativeElement, this._class, true);
    };
    __decorate([
        core_1.Input('name'), 
        __metadata('design:type', String)
    ], CustomIcon.prototype, "iconName", void 0);
    __decorate([
        core_1.Input('set'), 
        __metadata('design:type', String)
    ], CustomIcon.prototype, "iconSet", void 0);
    CustomIcon = __decorate([
        core_1.Directive({
            selector: 'custom-icon',
            host: {
                'role': 'img'
            }
        }), 
        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer])
    ], CustomIcon);
    return CustomIcon;
}());
exports.CustomIcon = CustomIcon;
//# sourceMappingURL=custom-icon.directive.js.map